import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=db7aedc2&scoped=true"
import script from "./PreLoader.vue?vue&type=script&lang=ts"
export * from "./PreLoader.vue?vue&type=script&lang=ts"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=db7aedc2&prod&lang=sass"
import style1 from "./PreLoader.vue?vue&type=style&index=1&id=db7aedc2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7aedc2",
  null
  
)

export default component.exports